export const BUTTON_THEMES = {
  DARK: "dark",
  DARKEST: "darkest",
  LIGHT: "light",
  MEDIUM: "medium",
};
